import AllSeries from './AllSeries';

export default AllSeries;
